import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '@auth0/auth0-angular';
import { map, switchMap } from 'rxjs/operators';
import { combineLatest, of } from 'rxjs';

import { DynamicFeatureFlagService, getAdminHomeUrl, OrganizationType, UserService } from 'shared/services';
import { retailersUrlPrefix } from 'src/app/retailer-platform/brand-shop/utils';

@Injectable()
export class ManufacturerGuard {
    constructor(
        private userService: UserService,
        private router: Router,
        private auth0Service: AuthService,
        private dynamicFeatureFlagService: DynamicFeatureFlagService
    ) {}

    public canActivate() {
        return combineLatest([this.userService.user$, this.auth0Service.user$]).pipe(
            switchMap(([user, auth0User]) => {
                const organizationType = user?.organization?.type || auth0User?.org_type;

                if (!organizationType) {
                    return of(this.router.parseUrl('signup'));
                }

                if (organizationType === OrganizationType.Manufacturer) {
                    return of(true);
                }

                if (organizationType === OrganizationType.Retailer) {
                    return of(this.router.parseUrl(`${retailersUrlPrefix}/home`));
                }

                if (organizationType === OrganizationType.Admin) {
                    return getAdminHomeUrl(this.dynamicFeatureFlagService).pipe(
                        map((url) => this.router.parseUrl(url.replace(/^\//, '')))
                    );
                }

                return of(false);
            })
        );
    }
}
